import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'
import Login from '../views/Login.vue'

import Projects from '../views/Projects/CRUD.vue'
import Activities from '../views/Activities/CRUD.vue'
import Publications from '../views/Publications/CRUD.vue'
import Members from '../views/Members/CRUD.vue'
import Resources from '../views/Resources/CRUD.vue'
import Datasets from '../views/Datasets/CRUD.vue'
import Users from '../views/Users/CRUD.vue'
import Categories from '../views/Categories/CRUD.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '*',
    name: 'Home',
    component: Home
  },
  {
    path: '/login',
    name: 'Login',
    component: Login
  },
  {
    path: '/projects',
    name: 'Projects',
    component: Projects
  },
  {
    path: '/activities',
    name: 'Activities',
    component: Activities
  },
  {
    path: '/publications',
    name: 'Publications',
    component: Publications
  },
  {
    path: '/members',
    name: 'Members',
    component: Members
  },
  {
    path: '/resources',
    name: 'Resources',
    component: Resources
  },
  {
    path: '/datasets',
    name: 'Datasets',
    component: Datasets
  },
  {
    path: '/users',
    name: 'Users',
    component: Users
  },
  {
    path: '/categories',
    name: 'Categories',
    component: Categories
  }
]

const router = new VueRouter({
  mode: 'history',
  routes
})

router.beforeEach((to, from, next) => {
  if (to.name !== 'Login' && !localStorage.getItem('token')) next({ name: 'Login' })
  else next()
})

export default router
